import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { setNavigate } from "../hooks/useNavigateHook";
import { setUserInfo } from "../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import Loader from "./Common/Loader";
import {
  clearTokens,
  getRefreshToken,
  setTokens,
} from "../utils/browserStorage";
import useApi from "../hooks/useApi";
import { REFRESH_ACCESS_TOKEN } from "../utils/apiConstants";
import paths from "../utils/paths";

export default function Auth() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { apiRequest } = useApi();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const refreshToken = getRefreshToken();
        if (!refreshToken) {
          setIsCheckingAuth(false);
          throw new Error("No refresh token found");
        }
        const response = await apiRequest({
          url: REFRESH_ACCESS_TOKEN,
          method: "post",
          data: { refreshToken },
        });
        if (response?.data) {
          const { accessToken, ...userInfo } = response.data;
          setTokens({ accessToken });
          dispatch(setUserInfo(userInfo));
        } else {
          console.error("Invalid response structure", response);
        }
        const currentPath = location.pathname;
        if (currentPath === "/") {
          navigate(paths.Profile);
        }
        console.log("refreshaccess toekn api calling fom auth component");
        return true;
      } catch (error) {
        navigate(paths.Root, {
          state: { redirectTo: location.pathname + location.search },
          replace: true,
        });
        clearTokens();
        dispatch(setUserInfo({}));
        console.log("error in the checkAuthentication:", error);
      } finally {
        setIsCheckingAuth(false);
      }
    })();
  }, [apiRequest, dispatch, navigate]);

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  if (isCheckingAuth) {
    return <Loader />;
  }

  return <Outlet />;
}
